import { FormControl, FormControlLabel, Radio, RadioGroup} from "@mui/material";
import {caseInsensitiveSort} from "../../common/Utils";
import "../Styles/AdminListings.css";

export const adminAccessControlColumns = (selectedRows, handleRoleChange, handleCheckboxChange) => [
    {
      name: 'Select',
      minWidth:"100px",
      cell: row => (
        <div style={{overflow:"hidden",textOverflow:"ellipsis"}}>
        <input
          style={{height:"15px", textAlign:"center", align:"center",justifyContent:"center"}}
          type="checkbox"
          checked={selectedRows.includes(row.userRoleId)}
          onChange={(e) => handleCheckboxChange(row.userRoleId, e.target.checked)}
        />
        </div>
      ),
      style: {
			      justifyContent: "center",
            textAlign:"center",
            minWidth:"100px",
		    },
    },
    {
        name: 'User Type',
        minWidth:"140px",
        sortable: true,
        selector: row => <div style={{overflow:"hidden",textOverflow:"ellipsis"}}>{row.userType}</div>,
        wrap: true,
        center:true,
        sortFunction: (rowA, rowB) => caseInsensitiveSort(rowA, rowB, (row) => row.userType? row.userType: ""),
        style: {
            minWidth:"140px",
			      justifyContent: "center",
            textAlign:"center",
		},
    },
    {
        name: 'User Name',
        minWidth:"250px",
        selector: row => <div style={{overflow:"hidden",textOverflow:"ellipsis"}}>{row.userName}</div>,
        sortable: true,
        wrap: true,
        center:true,
        style: {
			      justifyContent: "center",
            textAlign:"center",
            minWidth:"250px"
		},
        sortFunction: (rowA, rowB) => caseInsensitiveSort(rowA, rowB, (row) => row.userName? row.userName: ""),
    },
    {
        name: 'First Name',
        minWidth:"140px",
        selector: row => <div style={{overflow:"hidden",textOverflow:"ellipsis"}}>{row.firstName}</div>,
        sortable: true,
        wrap: true,
        center:true,
        style: {
			      justifyContent: "center",
            textAlign:"center",
            minWidth:"140px",
		},
        sortFunction: (rowA, rowB) => caseInsensitiveSort(rowA, rowB, (row) => row.firstName? row.firstName:""),
    },
    {
        name: 'Last Name',
        minWidth:"140px",
        selector: row => <div style={{overflow:"hidden",textOverflow:"ellipsis"}}>{row.lastName}</div>,
        sortable: true,
        wrap: true,
        center:true,
        style: {
			      justifyContent: "center",
            textAlign:"center",
            minWidth:"140px",
		},
        sortFunction: (rowA, rowB) => caseInsensitiveSort(rowA, rowB, (row) => row.lastName? row.lastName: ""),
    },
    {
        name: 'Care Facility',
        minWidth:"250px",
        selector: row => <div style={{overflow:"hidden",textOverflow:"ellipsis"}}>{row.careFacilityName}</div>,
        sortable: true,
        wrap: true,
        center:true,
        style: {
			      justifyContent: "center",
            textAlign:"center",
            minWidth:"250px",
		},
        sortFunction: (rowA, rowB) => caseInsensitiveSort(rowA, rowB, (row) => row.careFacilityName? row.careFacilityName: ""),
    },
    {
        name: 'Access',
        minWidth:"200px",
        cell: row => <div style={{overflow:"hidden",textOverflow:"ellipsis"}}>
      <FormControl>
        <RadioGroup
            row
            aria-labelledby="demo-row-radio-buttons-group-label"
            name="row-radio-buttons-group"         
            value={row.roleId || ''}
            onChange={(e) => {
              if(selectedRows.includes(row.userRoleId)){
                handleRoleChange(row.userRoleId, Number(e.target.value));
              }
            }
            }
        >
           <FormControlLabel 
            //disabled={!selectedRows.includes(row.userRoleId)} 
            value="1" 
            control={<Radio size="small"/>} 
            label="Read" />

            <FormControlLabel            
            //disabled={!selectedRows.includes(row.userRoleId)}
            value="2" 
            control={<Radio size="small"/>} 
            label="Write" />

            {/* {Object.entries(response.roles).map(([key,value])=> 
                <FormControlLabel 
                disabled={!selectedRows.includes(row.id)} 
                value={key}
                control={<Radio size="small"/>} 
                label={value} />
            )} */}

            {/*{(rolesList).map(obj => 
               <FormControlLabel 
                disabled={!selectedRows.includes(row.id)} 
                value={obj.roleId}
                control={<Radio size="small"/>} 
                label={obj.role} /> 
            )}*/}
        </RadioGroup>
        </FormControl>
            </div>,
           center:true,
           //align:"center",
           style: {
             justifyContent: "center",
             textAlign:"center",
             minWidth:"200px",
            },
    },   
];

export const aclExportColumns = [
  {
    header: 'User Type',
    key: 'userType'
  },
  {
    header: 'User Name',
    key: 'userName'
  },
  {
    header: 'First Name',
    key: 'firstName'
  },
  {
    header: 'Last Name',
    key: 'lastName'
  },
  {
    header: 'Care Facility',
    key: 'careFacilityName'
  },  
  {
    header: 'Access',
    key:'roleName',
  }
];
